export enum RedDayCriteriaType {
  Non_SMS = "nonSms",
  Non_Printing = "nonPrinting",
  Non_Email = "nonEmail",
  Non_EHF = "nonEhf",
}

export enum NonProductionDayType {
  Non_SMS = "isNonSMSDay",
  Non_Printing = "isNonPrintDay",
  Non_Email = "isNonEmailDay",
  Non_EHF = "isNonEhfDay",
}

export enum YearNavigation {
  NEXT = "Next",
  PREVIOUS = "Previous",
}

export type NonProductionDayTypeInterface =
  | RedDayCriteriaType.Non_Email
  | RedDayCriteriaType.Non_Printing
  | RedDayCriteriaType.Non_SMS
  | RedDayCriteriaType.Non_EHF;

export enum NonProductionDayTypeTranslationKey {
  Non_EHF = "NON_EHF",
  Non_SMS = "NON_SMS",
  Non_Printing = "NON_PRINTING",
  Non_Email = "NON_EMAIL",
}

export type RedDay = {
  id: number;
  startDate: string;
  endDate: string;
  reason: string;
  isFixedDate: boolean;
  isNonSMSDay: boolean;
  isNonPrintDay: boolean;
  isNonEmailDay: boolean;
  isNonEhfDay: boolean;
  isRecurring: boolean;
  status: number;
  modifiedBy: string;
  modifiedDate: string;
};

export type RedDayWithCriteria = {
  id: number;
  startDate: string;
  endDate: string;
  reason: string;
  isFixedDate: boolean;
  nonEhf: boolean;
  nonSms: boolean;
  nonPrinting: boolean;
  nonEmail: boolean;
  isRecurring: boolean;
  status: number;
  modifiedBy: string;
  modifiedDate: string;
};

export type NonProductionDataType = {
  [key: string]: Array<RedDay>;
};

export const NonProductionDayTabs = [
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_PRINTING_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_DOCUMENT_DOES_NOT_PRINT",
    type: NonProductionDayType.Non_Printing,
  },
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_SMS_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_SMS_DOES_NOT_SENT",
    type: NonProductionDayType.Non_SMS,
  },
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EMAIL_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_EMAIL_DOES_NOT_SENT",
    type: NonProductionDayType.Non_Email,
  },
  {
    name: "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.NON_EHF_DAYS",
    description:
      "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DAYS_AND_TIME_SLOTS_THAT_EHF_DOES_NOT_SENT",
    type: NonProductionDayType.Non_EHF,
  },
];

export enum NonProductionDayDrawerType {
  NONE = "none",
  ADD = "add",
  EDIT = "edit",
  VIEW = "view",
  WEEKEND_CONFIG = "weekend_config",
}

export const RedDayCriteriaMap: Record<string, RedDayCriteriaType> = {
  [NonProductionDayType.Non_SMS]: RedDayCriteriaType.Non_SMS,
  [NonProductionDayType.Non_Printing]: RedDayCriteriaType.Non_Printing,
  [NonProductionDayType.Non_Email]: RedDayCriteriaType.Non_Email,
  [NonProductionDayType.Non_EHF]: RedDayCriteriaType.Non_EHF,
};
